export default class LottieAnimation {
	constructor(el) {
        this.player = el;

        this.player.addEventListener('ready', () => {
            window.dispatchEvent(new CustomEvent('refresh-scroll'));
        });

		if(this.player.checkVisibility() !== false) {
			const src = this.player.getAttribute('data-source');
			this.player.load(src);
		}
	}

}